import * as React from "react";
import { DiaryCompliance } from "webportalclient";
import { DiaryComplianceModal } from "./DiaryComplianceModal";
import { DiaryBaselinesModal } from "./DiaryBaselinesModal";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";

interface DiarySubjectSummaryPanelProps {
    subjectId: string;
    siteNumber: string;
    subjectNumber: string;
    numberOfDays: number;
    complianceRecords: DiaryCompliance[];
    displayBaselines: boolean;
    displayCompliance: boolean;
}

export const DiarySubjectSummaryPanel = ({ subjectId, siteNumber, subjectNumber, numberOfDays, complianceRecords, displayBaselines, displayCompliance }: DiarySubjectSummaryPanelProps) => {
    const [complianceModalVisible, setComplianceModalVisible] = React.useState(false);
    const [baselinesModalVisible, setBaselinesModalVisible] = React.useState(false);
    const { fieldDisplayText } = useCurrentStudyConfigurationContext();

    const ComplianceRow = () => {
        return (
            <td>
                <button className="btn btn-primary btn-outline" onClick={() => setComplianceModalVisible(true)}>View Compliance</button>
            </td>
        );
    }

    const BaselinesRow = () => {
        return (
            <td>
                <button className="btn btn-primary btn-outline" onClick={() => setBaselinesModalVisible(true)}>View Participant Baselines</button>
            </td>
        )
    }

    return (
        <>
            <div className="panel panel-default" data-automationid="DiarySubjectSummaryPanel">
                <div className="panel-body">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Site Number</th>
                                <th>{fieldDisplayText.SubjectId}</th>
                                <th>Number of Days</th>
                                {displayCompliance ? <th>Compliance</th> : null}
                                {displayBaselines ? <th>Baselines</th> : null}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{siteNumber}</td>
                                <td>{subjectNumber}</td>
                                <td>{numberOfDays}</td>
                                {displayCompliance ? ComplianceRow() : null}
                                {displayBaselines ? BaselinesRow() : null}
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            {complianceModalVisible ? <DiaryComplianceModal records={complianceRecords} onClose={() => setComplianceModalVisible(false)} /> : null}
            {baselinesModalVisible ? <DiaryBaselinesModal subjectId={subjectId} onClose={() => setBaselinesModalVisible(false)} /> : null}
        </>
    );
}
